import * as React from 'react'

interface IMarkerProps {
  value: number
  color?: string
  className?: string
}

const Marker: React.FC<IMarkerProps> = ({ value, color, className }) => (
  <div
    className={'marker' + (className ? ` ${className}` : '')}
    style={{ left: `${value}%`, color }}
  >
    {value}%
  </div>
)

export default Marker



// WEBPACK FOOTER //
// ./src/components/Statistic/Progress/Marker.tsx